import { render, staticRenderFns } from "./SonsMergeClosedCard.vue?vue&type=template&id=f31199e2&scoped=true&"
import script from "./SonsMergeClosedCard.vue?vue&type=script&lang=js&"
export * from "./SonsMergeClosedCard.vue?vue&type=script&lang=js&"
import style0 from "./SonsMergeClosedCard.vue?vue&type=style&index=0&id=f31199e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31199e2",
  null
  
)

export default component.exports